<template>
  <div class="headermain">
    <div v-if="showFixed" class="zpd_fixed">
      <div class="main">
        <img src="@/assets/img/弹窗.png" />
        <div @click="handleShowFixed">
          {{ num == 0 ? "我知道了" : `我知道了(${num}秒)` }}
        </div>
      </div>
    </div>
    <div class="zpd_sider">
      <img src="@/assets/img/侧边栏.png" />
      <div @click="handleShowFixed">点击查看声明</div>
    </div>
    <!-- <div class="zpd_modal">
      <div class="modal">
        <div class="titles">重要提示</div>
        <div class="h1">
          关于调整住建领域施工现场专业人员及建筑工人
        </div>
        <div class="h2">
          职业培训技术服务保障职能公告
        </div>
        <div class="title">各培训机构和学员：</div>
        <div class="p">
          根据工作需要，现将住建领域施工现场专业人员及建筑工人职业培训技术服务保障等工作职能从江西省建设工程学校调整至江西省人居环境研究院。调整期间，请各培训机构和学员暂缓开展相关施工现场专业人员及建筑工人培训测试等工作，待交接完毕后再行开展，时间另行通知。
        </div>
        <div class="bottom">以上，望知悉。</div>
        <div class="school">江西省建设工程学校</div>
        <div class="time">2024年03月01日</div>
        <div class="flex">
          <div class="button" @click="handleClone">我知道了</div>
        </div>
      </div>
    </div> -->
    <div v-show="ShowLogo" class="header1">
      <div class="logo">
        <img src="../assets/img/logo.png" alt srcset />
      </div>
    </div>
    <div v-show="ShowLogo" class="banner">
      <img src="../assets/img/banner.png" alt srcset />
      <img class="box-sh" src="../assets/img/box-sh.png" alt srcset />
      <div class="navs">
        <div class="nav">
          <Menu mode="horizontal" :theme="theme1" :active-name="activename">
            <MenuItem to="/" name="pageHome">首页</MenuItem>
            <MenuItem to="/enterprise" name="pageActionposter"
              >政策文件</MenuItem
            >
            <MenuItem to="/initiatives" name="pageInitiatives"
              >通知公告</MenuItem
            >
            <MenuItem to="/actionposter" name="pageNews">资料下载</MenuItem>
            <MenuItem to="/news" name="pageEnterprise">信息动态</MenuItem>
          </Menu>
        </div>
      </div>
    </div>
    <floatView
      v-if="showView"
      @HideModel="HideModel"
      :json="json"
      @closeView="closeView"
    ></floatView>
    <router-view />
    <Footer></Footer>
  </div>
</template>
<style lang="less">
@import url("./../assets/css/main.less");
</style>
<script>
import Footer from "../components/footer";
import floatView from "../components/floatlayer";
export default {
  components: {
    floatView,
    Footer
  },
  data() {
    return {
      showView: true,
      theme1: "light",
      activename: "pageHome",
      ShowLogo: true,
      json: {
        left: 100,
        top: 400,
        directionX: 1,
        directionY: 1,
        distance: null,
        interval: null,
        target: null,
        zIndex: 9999,
        width: null,
        height: null,
        noHoverPause: null, //鼠标经过时不停止，为true时不停止
        cursor: null
      },
      num: 10, //10秒倒计时
      time: null,
      showFixed: false
    };
  },
  created() {},
  methods: {
    handleClone() {
      const dom = document.querySelector(".zpd_modal");
      dom.style.display = "none";
    },
    handleShowFixed() {
      if (this.showFixed) {
        if (this.num <= 0) {
          this.showFixed = false;
        }
      } else {
        this.showFixed = true;
        this.time = setInterval(() => {
          this.num--;
          if (this.num <= 0) {
            clearInterval(this.time);
            this.num = 0;
          }
        }, 1000);
      }
    },
    HideModel() {
      this.showView = false;
    },
    closeView(val) {
      this.showView = false;
    },
    iniPage() {
      let _this = this;
      let path = _this.$route.path.trim();
      if (path.indexOf("/index") >= 0) {
        _this.activename = "pageHome";
      }
      if (path.indexOf("/news") >= 0) {
        // _this.activename = 'pageNews'
        _this.activename = "pageEnterprise";
      }
      if (path.indexOf("/initiatives") >= 0) {
        // _this.activename = 'pageInitiatives'
        _this.activename = "pageInitiatives";
      }
      // if (path.indexOf('/videos') >= 0) {
      //   // _this.activename = 'pageVideos'
      //   _this.activename = 'pageNews'
      // }
      if (path.indexOf("/actionposter") >= 0) {
        // _this.activename = 'pageActionposter'
        _this.activename = "pageNews";
      }
      if (path.indexOf("/enterprise") >= 0) {
        // _this.activename = 'pageEnterprise'
        _this.activename = "pageActionposter";
      }
    }
  },
  mounted() {
    // console.log('mounted')
    // console.log(this.$route.path)

    // if(path === '/index' || path === '/enterprise'|| path === '/initiatives'|| path === '/actionposter'|| path === '/news'){
    //   this.ShowLogo = true
    // }else {
    //   this.ShowLogo = false
    // }
    this.iniPage();
  },
  beforeUpdate() {
    //  let path = this.$route.path
    // if(path === '/index' || path === '/enterprise'|| path === '/initiatives'|| path === '/actionposter'|| path === '/news'){
    //   this.ShowLogo = true
    // }else {
    //   this.ShowLogo = false
    // }
    // console.log('beforeUpdate')
    this.iniPage();
  }
};
</script>
<style scope lang="less">
.zpd_sider {
  width: 177px;
  height: 274px;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  z-index: 9999;
  img {
    width: 100%;
    height: 100%;
  }
  div {
    position: absolute;
    bottom: 26px;
    left: 50%;
    transform: translateX(-50%);
    width: 120px;
    height: 36px;
    background: linear-gradient(0deg, #d1272d 0%, #f33e45 100%);
    border-radius: 18px;
    font-size: 14px;
    font-family: Source Han Serif CN;
    font-weight: 800;
    color: #ffffff;
    line-height: 20px;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
  }
}
.zpd_fixed {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  .main {
    width: 620px;
    height: 562px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    div {
      cursor: pointer;
      position: absolute;
      bottom: 35px;
      left: 50%;
      transform: translateX(-50%);
      padding: 0px 30px;
      height: 36px;
      background: linear-gradient(0deg, #d1272d 0%, #f33e45 100%);
      border-radius: 18px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 36px;
    }
  }
}
.zpd_modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  .modal {
    width: 800px;
    height: 750px;
    border-radius: 10px;
    background: #ffffff url("../assets/img/图.png") no-repeat 0 0;
    padding: 0 50px;
    padding-top: 260px;
    .titles {
      color: #c61a21;
      text-align: center;
      font-weight: bold;
      font-size: 36px;
      letter-spacing: 1em;
      margin-bottom: 13px;
      padding-left: 40px;
    }
    .h1,
    .h2 {
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      text-align: center;
    }
    .title {
      margin-top: 24px;
      font-family: Source Han Sans CN;
      font-weight: 600;
      font-size: 17px;
      color: #333333;
    }
    .p,
    .bottom {
      font-family: Source Han Sans CN;
      font-weight: 600;
      font-size: 17px;
      color: #333333;
      line-height: 30px;
      text-indent: 2em; /* 使用em单位设置首行缩进为2个em */
    }
    .school {
      margin-top: 20px;
      text-align: right;
      font-family: Source Han Sans CN;
      font-weight: 600;
      font-size: 17px;
      color: #333333;
    }

    .time {
      margin-top: 10px;
      text-align: right;
      font-family: Source Han Sans CN;
      font-weight: 600;
      font-size: 17px;
      color: #333333;
    }
    .flex {
      margin-top: 20px;
      width: 100%;
      display: flex;
      justify-content: center;
      .button {
        width: 136px;
        height: 40px;
        background: linear-gradient(0deg, #c62127 0%, #ff4950 100%);
        border-radius: 20px;
        text-align: center;
        line-height: 40px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue